import React from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from "./messages";
import { Button } from '@arnsbogroup/react-voicearchive'

const SignIn = ({ logo, name, url, onSubmit, loading }) => {
  const { formatMessage } = useIntl()
  return(
  <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-md w-full space-y-8">
      <div>
        <img className="mx-auto h-12 w-auto" src={logo} alt={name} />
        <p className="mt-12 text-center text-sm text-gray-600">
          <FormattedMessage {...messages.logToAccount}/>
        </p>
      </div>
      <form className="mt-8 space-y-6" onSubmit={onSubmit}>
        <div className="rounded-sm shadow-sm -space-y-px">
          <div>
            <label htmlFor="username" className="sr-only"><FormattedMessage {...messages.username}/></label>
            <input id="username" name="username" type="text" autoComplete="username" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-sm focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm" placeholder={formatMessage(messages.username)} />
          </div>
          <div>
            <label htmlFor="password" className="sr-only"><FormattedMessage {...messages.password}/></label>
            <input id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-sm focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm" placeholder={formatMessage(messages.password)} />
          </div>
        </div>

        <div>
          <Button 
            size='sm'
            disabled={loading} 
            type="submit"
            className="w-full"
            icon={['fa', 'lock']}
          >
            { loading ? formatMessage(messages.signingIn) : formatMessage(messages.signIn) }
          </Button>
        </div>
      </form>

      <div className="mt-6">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-gray-50 text-gray-500">
              <FormattedMessage {...messages.forgotUser}/>
            </span>
          </div>
        </div>

        <Link to="/user/forgot">
          <Button
            variant="outline"
            size="sm"
            className="w-full"
            icon={['fa', 'long-arrow-right']}
            iconPosition="right"
          >
            <FormattedMessage {...messages.helpAccess}/> { name } <FormattedMessage {...messages.dashboard}/>
          </Button>
        </Link>
      </div>
    </div>
  </div>
)}

export default SignIn
